import en from './en'
import ru from './ru'
import { useLocation, useHistory } from 'react-router-dom'
const translations = {
  en,
  ru,
}

export const defaultLang = 'ru'
export const langs = Object.keys(translations)

export const useLang = () => {
  const location = useLocation()
  const history = useHistory()
  const search = new URLSearchParams(location.search)
  const setLang = (lang) => {
    if (defaultLang === lang) {
      history.push(location.pathname)
    } else {
      history.push(location.pathname + '?lang=' + lang)
    }
  }

  return {
    lang: search.get('lang') || defaultLang,
    setLang,
    langs,
    defaultLang,
  }
}
export const useText = () => {
  const { lang } = useLang()
  return (key) =>
    translations[lang || defaultLang][key] !== undefined
      ? translations[lang || defaultLang][key]
      : key
}
